import type {ImageLoader} from 'next/image'

// https://kontent.ai/learn/learn/docs/apis/image-transformation-api

export const loadImageFromKontentAI: ImageLoader = ({src, width, quality}) => {
	if (!src) return src
	let url: URL
	try {
		url = new URL(src)
	} catch {
		return src
	}

	url.searchParams.set('w', String(width))
	url.searchParams.set('q', String(quality ?? 75))
	url.searchParams.set('auto', 'format')
	return url.toString()
}
